<template>
  <transition name="fade-in-up">
    <router-view></router-view>
  </transition>
</template>

<script>
import { SET_MENU } from '@/core/services/store/modules/menu.module';
import { SideBar } from '@/core/config/menu/sideBar';
import { DEFAULT_TITLE } from '../../../utils/constants';

export default {
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || DEFAULT_TITLE;
      },
    },
  },
  mounted() {
    // Reuse menu group BILL (sidebar đã có entry "Đề nghị tạo HĐ" cùng group).
    this.$store.dispatch(SET_MENU, SideBar.BILL);
  },
};
</script>
